// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { BarChartHorizontal as RawBarChartHorizontal } from "lucide-react";
export const BarChartHorizontal = /* @__PURE__ */ createIcon(RawBarChartHorizontal, "BarChartHorizontal", 2);
